import React from "react";
import { Link } from "react-router-dom";

export default function ScrollToTopButton() {
  return (
    <div className="scrollToTop">
      <Link
        to="https://wa.me/244935516476?text=Hello%2C%20I%20would%20like%20to%20get%20in%20touch%20regarding%20...."
        target="_blank"
        rel="noopener noreferrer"
      >
        <img
          src="/assets/img/whatsappIcon.svg"
          alt="whatsApp"
          style={{ cursor: "pointer" }}
        />
      </Link>
    </div>
  );
}
